import React from 'react';

const ReportSection = ({ title, children, project, period, showTitle = true }) => {
    const renderFormattedTitle = (text) => {
        if (!text) return null;

        const match = text.match(/^(.*?)\s*(\(.*?\))(.*)$/);

        if (match) {
            return (
                <>
                    {match[1]}{' '}
                    <span className="font-medium">{match[2]}</span>
                    {match[3]}
                </>
            );
        }
        return text;
    };

    return (
        <div className="w-full pb-[10mm] relative z-10 bg-transparent">
            <table className="w-full border-collapse">

                <thead className="table-header-group">
                <tr>
                    <td>
                        <div className="w-full h-[135px] pt-[55px] px-[60px] flex flex-col justify-start">
                            <header className="mb-3">
                                <h1 className="text-[#000034] font-extrabold text-2xl flex items-center gap-2">
                                    Relatório de Serviços Prestados
                                    <span className="font-normal text-gray-700">- {project}</span>
                                </h1>
                                <p className="text-gray-400 text-sm mt-[10px]">Período de {period}</p>
                            </header>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td className="h-[30px] border-none">&nbsp;</td>
                </tr>

                </thead>

                <tfoot className="table-footer-group">
                <tr>
                    <td className="h-[20px] border-none">&nbsp;</td>
                </tr>
                <tr>
                    <td>
                        <div className="h-[115px] w-full block"></div>
                    </td>
                </tr>
                </tfoot>

                <tbody className="table-row-group">
                <tr>
                    <td className="px-[52px]">
                        <div className="bg-transparent px-8 pb-2">

                            {showTitle && (
                                <div className="mb-6 break-inside-avoid">
                                    <h2 className="text-[22px] font-bold text-[#156DC4] mb-2">
                                        {renderFormattedTitle(title)}
                                    </h2>
                                    <div className={`w-full h-[0.5px] rounded-full bg-[#156DC4]`}></div>
                                </div>
                            )}

                            {children}

                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default ReportSection;
